import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

/**
 * getEarnings: Fetches markets/events tagged as 'earnings'.
 * Includes robust error handling with try-catch.
 */
export const getEarnings = async (): Promise<any[]> => {
  try {
    const response = await axiosClient.get(API_ENDPOINTS.MARKETS_EVENTS_LIST, {
      params: {
        limit: 100,
        offset: 0,
        order: 'createdAt',
        ascending: true,
        tag_slug: 'earnings',
        related_tags: false,
        active: true,
        type: 'earnings',
        closed: false,
      },
    });

    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }

    // Log unexpected response structure but return empty array to prevent UI crashes
    if (response.data && !response.data.success) {
      console.warn('Earnings API returned success: false', response.data.message);
    }

    return [];
  } catch (error) {
    console.error('Failed to fetch earnings markets:', error);
    // Return empty array on failure to allow UI to handle empty state gracefully
    return [];
  }
};

export const earningsApi = {
  getEarnings,
};
